import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
    'https://lfzkupyttfpdqoedcpno.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxmemt1cHl0dGZwZHFvZWRjcG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3NzU1OTMsImV4cCI6MjA2NTM1MTU5M30.8HPsuc-pcHuluhsHlxDcrOFvhuuU5eq8GCxo8vuEJsA'
);